import { render, staticRenderFns } from "./noniatadevreraporu.vue?vue&type=template&id=0410e56a&scoped=true"
import script from "./noniatadevreraporu.vue?vue&type=script&lang=js"
export * from "./noniatadevreraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410e56a",
  null
  
)

export default component.exports